import { parsePathFiltersFromPathname } from "../utils/parsePathFiltersFromPathname";
/**
 * Facets endpoint only receives query params; path-segment filters must be
 * forwarded explicitly from the listing pathname.
 */
export function buildFacetsApiUrl(facetsBaseUrl, pathname = window.location.pathname, search = window.location.search, lockedFinanceType = null, hiddenFilters = {}) {
    const base = facetsBaseUrl.replace(/\?.*$/, "");
    const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
    const pathFilters = parsePathFiltersFromPathname(pathname);
    Object.entries(pathFilters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
            params.set(key, String(value));
        }
    });
    if (lockedFinanceType) {
        params.set("finance_type", lockedFinanceType);
    }
    Object.entries(hiddenFilters).forEach(([key, value]) => params.set(key, value));
    const qs = params.toString();
    return qs ? `${base}?${qs}` : base;
}
